export const mapSortIdToField = (id: string): string => {
  switch (id) {
    case 'name':
      return 'public_agreements_name.enum';
    case 'registration_plate':
      return 'public_agreements_registration_plate.enum';
    case 'index':
      return 'public_agreements_index_id.enum';
    case 'step':
      return 'public_agreements_step_id.enum';
    case 'assignee':
      return 'public_agreements_assignee_id.enum';
    case 'creator':
      return 'public_agreements_creator_id.enum';
    case 'created':
      return 'public_agreements_created';
    case 'modified':
      return 'public_agreements_modified';
    case 'insurance_object':
      return 'public_agreements_insurance_object_id.enum';
    default:
      return `public_agreements_${id}`;
  }
};
